/**
 * Every word a player reads about a death's penalty, in one place, so an edit of the author's is one change
 * (P2.2-T23, P2.5-T7; ADR-079's amendment of 2026-10-04, item 7): the effect's tooltip lines and the death screen's
 * cost line. `screen`: the death screen's title, its respawn button and the countdown beside it (`{place}` the point's name or
 * its kind's, `{seconds}` a number). All of them are drafts for the author. `{held}` and `{most}` are numbers as the page prints them;
 * `{parts}` is a list the page joins with a comma and a space.
 */
export const DEATH = {
  deaths: {
    pve: "a death to a creature",
    pvp: "a death to another character",
    hostile: "a death in a Hostile zone",
  },
  follows: "The penalty for {death}.",
  stacks: "{held} of {most} stacks.",
  modifiers: {
    damageDealt: "damage dealt",
    damageTaken: "damage taken",
    maxHealth: "maximum health",
    cooldown: "cooldowns",
  },
  modifier: "{percent} {words}",
  cost: "{name}: {parts}",
  screen: {
    title: "You died",
    respawnAt: "Respawn at {place}",
    respawn: "Respawn",
    countdown: "You can respawn in {seconds} s.",
    shrine: "the shrine",
    safePlace: "the nearest safe place",
  },
} as const;
